/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Detail_OutputInputs */

const es_chat_tool_detail_output = /** @type {(inputs: Chat_Tool_Detail_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultado`)
};

const en_chat_tool_detail_output = /** @type {(inputs: Chat_Tool_Detail_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Result`)
};

/**
* | output |
* | --- |
* | "Result" |
*
* @param {Chat_Tool_Detail_OutputInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_output = /** @type {((inputs?: Chat_Tool_Detail_OutputInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_OutputInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_output(inputs)
	return en_chat_tool_detail_output(inputs)
});
export { chat_tool_detail_output as "chat.tool_detail.output" }